// relations signs
export const REP = 'REP';
export const WARD = 'WARD';
export const ANY = 'ANY';
